module.exports = __webpack_public_path__ + "img/8.2437a34e.svg";